import { action } from 'satcheljs/lib/legacy';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import setIsSearching from '../setIsSearching';
import processResponseResults from './processResponseResults';
import updateFindResultTransactionId from '../updateFindResultTransactionId';
import addTransactionComplete from 'owa-recipient-common/lib/utils/addTransactionComplete';
import { getSuggestionsService } from './getSuggestionsService';
import { FindResultType } from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import postProcessSuggestionsResult from './postProcessSuggestionsResult';
import { populateFeedbackStateNetwork } from 'owa-readwrite-recipient-well-fabric/lib/utils/populateFeedbackState';
import { now } from 'owa-datetime';

const MAX_ENTRIES_DIRECTORY = 20;

export default action('autoSearchDirectory')(async function autoSearchDirectory(
    recipientWell: FindControlViewState,
    recipients: ReadWriteRecipientViewState[],
    queryString: string,
    resolveIfSingle?: boolean
): Promise<void> {
    let suggestionService = getSuggestionsService();
    let transactionStartTime = now();
    let response = await suggestionService(queryString, true /* searchDirectory*/);
    setIsSearching(recipientWell, false);
    let sameQueryString = recipientWell.queryString.trim() == queryString;

    if (sameQueryString) {
        let maxFindResultShown = MAX_ENTRIES_DIRECTORY;
        processResponseResults(
            recipientWell.findResultSet,
            response,
            false /*appendResults*/,
            maxFindResultShown,
            true /*returnMaskedRecipients*/
        );

        populateFeedbackStateNetwork(
            recipientWell,
            transactionStartTime,
            response,
            true /*directory*/
        );
        updateFindResultTransactionId(recipientWell, response);
        addTransactionComplete(recipientWell, transactionStartTime);
        recipientWell.hasSearchedDirectory = true;
        /* manually trigger rerender if the response has 0 elements */
        if (recipientWell.findResultSet.length == 0) {
            recipientWell.findResultSet = [];
        }
        await postProcessSuggestionsResult(
            recipientWell,
            recipients,
            FindResultType.SearchDirectory,
            resolveIfSingle
        );
    }
});
